import { ShortUrl } from '@air/api';
import { ClipSource } from '@air/api/types';
import { type Upload } from '@air/redux-uploader';
import { callRequestWithRetry } from '@air/upload-utils';
import { reportErrorToBugsnag } from '@air/utils-error';

type GetSmallPublicUploadUrlsParams = {
  apiUploadData: Upload['apiUploadData'][];
  shortBoardId: string;
  sessionId: string;
};

export const fetchSmallPublicUploadUrl = async ({
  sessionId,
  shortBoardId,
  apiUploadData,
}: GetSmallPublicUploadUrlsParams) => {
  try {
    const urls = await callRequestWithRetry(() =>
      ShortUrl.getUploadUrls(shortBoardId, apiUploadData, {
        source: ClipSource.web,
        sessionId,
      }),
    );

    return urls;
  } catch (error) {
    throw reportErrorToBugsnag({
      error,
      context: `Failed to get public small upload url`,
      metadata: {
        data: {
          apiUploadData,
        },
      },
    });
  }
};
